// extracted by mini-css-extract-plugin
export default {"NewsItem":"index_NewsItem_I2V4s","listItem":"index_listItem_FVrqn","text":"index_text_lSSyr"};